import React from 'react'
import Anime from '../../components/Anime/Anime'

const Gauge = ({ rotation, handleClick }) => (
  <svg
    onClick={e => handleClick(e)}
    width="313px"
    height="162px"
    viewBox="0 0 313 162"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ overflow: 'visible' }}
    className="mv4"
  >
    <defs>
      <path
        d="M165.07557 138.7584l-4.37982-40.80516C160.39345 95.13653 158.01579 93 155.18228 93c-2.8323 0-5.20996 2.13653-5.51226 4.95324l-4.37982 40.80756c-.28551 2.65957-1.9338 4.94725-4.31505 6.16846-10.51349 5.3911-17.56487 16.57279-16.93627 29.34037.77376 15.69586 13.47056 28.57501 29.15683 29.5491 18.1287 1.12885 33.18396-13.24143 33.18396-31.1278 0-12.13538-6.93382-22.64768-17.05384-27.80246-2.36085-1.20202-3.96835-3.4969-4.25026-6.13007"
        id="b"
      />
      <filter
        x="-57.7%"
        y="-32.5%"
        width="215.4%"
        height="164.9%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="12"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.203921569 0 0 0 0 0.207843137 0 0 0 0 0.345098039 0 0 0 0.11 0"
          in="shadowBlurOuter1"
        />
      </filter>
    </defs>

    <g fill="none" fillRule="evenodd">
      <g id="book">
        <path
          d="M3.8637 22.23505l42.87903-11.4894c5.33466-1.42942 10.81803 1.7364 12.24745 7.07107l16.04407 59.8773c.14294.53346-.17364 1.0818-.7071 1.22474L22.75478 92.73753c-2.13387.57177-4.32722-.69456-4.89898-2.82843L1.03528 27.13403c-.57177-2.13387.69456-4.32721 2.82842-4.89898z"
          fill="#402A67"
        />
        <path
          d="M21.3451 81.7806l43.54166-11.66695 5.71617-4.25738 2.62658 9.80251c.14294.53347-.17364 1.0818-.7071 1.22475L23.54906 90.00589c-2.27135.60861-4.60602-.73931-5.21463-3.01066-.6086-2.27135.73932-4.60602 3.01067-5.21463z"
          fill="#FFF"
        />
        <path
          d="M4.70017 22.01092L54.47014 8.6751c1.06693-.28589 2.1636.34728 2.44949 1.4142l15.34393 57.26435c.14294.53347-.17364 1.0818-.7071 1.22475l-50.7359 13.59464-16.1204-60.16212z"
          fill="#79B5FF"
        />
        <path
          fill="#FEBD65"
          d="M22.26435 83.80122l8.92703-2.39199 4.51859 16.86361-5.18572-1.49932-3.7413 3.89131z"
        />
      </g>
      <g transform="translate(111 -7)" id="clock">
        <circle cx="36" cy="36" r="36" transform="translate(9 7)" fill="#9CC3F6" />
        <path
          d="M45.96412 66.66667v6.93895m0-60.27229v6.93895m-24 22.39439h-6.93895m60.27228 0H68.3585M28.91506 60.33978l-4.90658 4.90658m42.61894-42.61894L61.72084 27.534m-32.80579-1.13535l-4.90658-4.90658m42.61895 42.61894l-4.90658-4.90658"
          stroke="#5D7BE4"
          strokeLinecap="round"
          strokeWidth="3"
        />
        <path
          d="M46 40.33431V13M34.0943 54.71848L46.9067 42"
          stroke="#402A67"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <circle fill="#FFF" cx="46" cy="42" r="6" />
      </g>
      <g transform="rotate(-25 171.63662 -465.95002)" id="stetoscope">
        <circle fill="#5573d8" cx="44.4386" cy="42.615" r="42.48934" />
        <path
          d="M27.84056 47.4663v19.18547c0 9.35642 7.58487 16.9413 16.9413 16.9413 9.35641 0 16.94129-7.58488 16.94129-16.9413v-7.8191c0-11.18446 9.0668-20.25126 20.25125-20.25126"
          stroke="#9CC3F6"
          strokeWidth="4"
        />
        <path
          d="M45.11815 10.1073l.3051 17.47924c.1685 9.65353-7.52063 17.61585-17.17415 17.78435-9.65352.1685-17.61585-7.52062-17.78435-17.17414l-.3051-17.47925"
          stroke="#402A67"
          strokeWidth="6"
        />
        <circle fill="#FFF" cx="82.30702" cy="37.29537" r="9.00233" />
        <path
          d="M10.28838 10.28838h4.28578m25.2933 0h4.28578"
          stroke="#402A67"
          strokeWidth="6"
          strokeLinecap="round"
        />
      </g>
      <Anime
        elasticity="600"
        rotate={rotation}
        // translateX={[-31, -31]}
        // translateY={[-31, -31]}
        duration="2000"
        // delay={(target, i) => i * 100 + 800}
      >
        <g
          style={{ transformOrigin: '160px 168px 0px', position: 'relative' }}
          className="relative"
          transform="translate(0 -10)"
        >
          <use fill="#000" filter="url(#a)" xlinkHref="#b" />
          <use fill="#FFF" xlinkHref="#b" />
        </g>
        {/* <path
          style={{ transformOrigin: '160px 130px', position: 'relative' }}
          className="relative"
          d="M192.133926,58.1785922 C192.092245,57.461848 191.496953,56.9016585 190.777688,56.9016585 C190.056285,56.9016585 189.459925,57.461848 189.419312,58.1785922 L185.141125,132.185367 C172.821697,134.772249 163.570637,145.662928 163.570637,158.71023 C163.570637,173.683049 175.751128,185.819777 190.777688,185.819777 C205.80211,185.819777 217.982601,173.683049 217.982601,158.71023 C217.982601,145.662928 208.73261,134.772249 196.411045,132.185367 L192.133926,58.1785922 Z"
          fill="#FFFFFF"
          transform="translate(43.911297, 37.607434) rotate(-48.000000) translate(-43.911297, -37.607434) "
        /> */}
      </Anime>
    </g>
  </svg>
)

export default Gauge



// WEBPACK FOOTER //
// ./src/components/Gauge/Gauge.js